import React, { useContext, useEffect, useRef } from "react";
import TableAutoComponent from "../../components/complex/crud/TableAutoComponent";
import FilterComponent from "../../components/complex/crud/FilterComponent";
import generateFilterConfigs from "../../utils/FilterConfigGenerator";
import generateTableConfigs from "../../utils/TableConfigGenerator";

import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Paginator } from "primereact/paginator";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";

import useSelectorDialogControl from "../../custom_hooks/complex/useSelectorDialogControl";
import UiContext from "../../store/ui-context";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputTextarea } from "primereact/inputtextarea";
import useIsMobile from "../../hooks/useIsMobile";

const apiName = "masterdata/pengecekanmobiloption";
const orderBy = "keterangan";
const orderMethod = "ASC";
const additionalParams = {};

const customColumns = [];

const configs = [
  // add_configs
  {
    name: "Keterangan",
    field: "keterangan",
    type: "text_plain",
    table: true,
    filter: true,
  },
];

const filterConfigs = generateFilterConfigs(configs);
const tableConfigs = generateTableConfigs(configs);

const onReloadSuccess = (data) => {
  const inputElement = document.querySelector("#filterInput");
  if (inputElement) {
    inputElement.focus();
  }
};


const PengecekanMobilOptionSelectorDialog = (props) => {
  const isMobile = useIsMobile();
  const single = props.single ?? true;
  const { title, kendaraanJenisId, labelGrup, loadings } = props;
  const uiContext = useContext(UiContext);

  const {
    toast,
    listData,
    paging,
    loading,
    setListData,
    selectedRows,
    setSelectedRows,
    refineValue,
    reloadListData,
    handleOnFilter,
    handleOnPage,
    handleSelectionChange,
    // API
    requestGet,
    requestGetOne,
    requestPost,
    requestDelete,
  } = useSelectorDialogControl({
    apiName,
    orderBy,
    orderMethod,
    additionalParams,
    visible: props.visible,
    onReloadSuccess,
    take: 30,
    additionalFilter: props.additionalFilter,
  });

  const refNewOptionLabel = useRef(null);
  const [filterTextKeterangan, setFilterTextKeterangan] = React.useState("");
  const [showAddNewDialog, setShowAddNewDialog] = React.useState(false);

  useEffect(() => {
    if (props.visible) {
      setFilterTextKeterangan("");
    }
  }, []);

  const handleOnClickAddNew = () => {
    setShowAddNewDialog(true);
  };

  const handleOnConfirmAddNew = async () => {
    const newLabel = refNewOptionLabel.current.value;
    if (newLabel && newLabel.length >= 1) {
      let _newLabel = newLabel.trim().toUpperCase();

      const body = {
        kendaraan_jenis_id: kendaraanJenisId > 0 ? kendaraanJenisId : null,
        keterangan: _newLabel,
        urutan: 0,
        utama: 0,
        label_grup: labelGrup ? labelGrup : "",
      };

      await requestPost({
        fullUrl: "/api/masterdata/pengecekanmobiloption/save",
        body,
        isForm: false,
        onError: ({ message, data }) => {
          uiContext.showErrorMsg("Error", message);
        },
        onSuccess: ({ data, message }) => {
          uiContext.showSuccessMsg("Success", message);

          const refinedValue = refineValue([data]);
          props.onConfirm(null, refinedValue);
          setShowAddNewDialog(false);
        },
      });
    } else {
      uiContext.showErrorMsg("Error", "Label tidak boleh kosong");
    }
  };

  const handleOnConfirmFilterTextKeterangan = () => {
    const filterText = filterTextKeterangan.toLowerCase();

    handleOnFilter({
      alias: {},
      compare_method: "or",
      filter: [
        {
          config: {
            name: "Keterangan",
            field: "keterangan",
            type: "text_plain",
            table: true,
            filter: true,
            value: "keterangan",
          },
          field: "keterangan",
          value: {
            operator: "none",
            value: [filterText],
          },
        },
      ],
    });
  };

  const dialogFooter = (
    <div className="col-center-center w-100">
      <Paginator
        first={parseInt(paging.take) * parseInt(paging.page - 1)}
        rows={parseInt(paging.take)}
        totalRecords={parseInt(paging.total)}
        rowsPerPageOptions={[5, 8, 10, 20, 50]}
        onPageChange={handleOnPage}
        template={
          isMobile
            ? {
              layout: "PrevPageLink PageLinks NextPageLink",
            }
            : {
              layout:
                "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
            }
        }
        pt={{}}
      />
      <div className="row-between-end w-100">
        <Button
          label={isMobile ? "Tambah" : "Tambah Baru"}
          icon="pi pi-plus"
          loading={loading || loadings}
          onClick={handleOnClickAddNew}
        />
        <div className="row-end-end">
          <Button
            label="Cancel"
            icon="pi pi-times"
            outlined
            loading={loading || loadings}
            onClick={props.onHide}
          />
          <Button
            label="Pilih"
            icon="pi pi-check"
            loading={loading || loadings}
            onClick={(e) => {
              let refinedValue = refineValue(selectedRows);

              if (isMobile) {
                refinedValue = [refinedValue];
              }
              props.onConfirm(e, refinedValue);
            }}
          />
        </div>
      </div>
    </div>
  );

  // const CustomSmallFilter = () => {
  //   return (
  //   );
  // };

  return (
    <Dialog
      visible={props.visible}
      header={title}
      modal
      className={`p-fluid w-[44rem] min-h-[30rem]`}
      footer={dialogFooter}
      onHide={props.onHide}
      contentStyle={{ paddingBottom: "0px" }}
    >
      <Dialog
        visible={showAddNewDialog}
        onHide={() => setShowAddNewDialog(false)}
        header={"Tambah Label Baru"}
        footer={
          <div className="row-end-end">
            <Button
              label="Cancel"
              icon="pi pi-times"
              outlined
              onClick={() => setShowAddNewDialog(false)}
            />
            <Button
              label="Save"
              icon="pi pi-save"
              onClick={(e) => {
                handleOnConfirmAddNew();
              }}
            />
          </div>
        }
        contentStyle={{ paddingTop: "2px", paddingBottom: "20px" }}
      >
        <InputTextarea
          ref={refNewOptionLabel}
          className=" w-[20rem] md:w-[25rem]"
        />
      </Dialog>

      <div className={`col-start-start w-100 gap-3 pt-1`}>
        {isMobile && (
          <div className="row-start-center gap-2 w-full">
            <IconField iconPosition="left">
              <InputIcon className="pi pi-search"> </InputIcon>
              <InputText
                id="filterInput"
                className="!pl-10"
                placeholder="Cari keterangan..."
                value={filterTextKeterangan}
                autoFocus={true}
                onChange={(e) => setFilterTextKeterangan(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleOnConfirmFilterTextKeterangan();
                  }
                }}
              />
            </IconField>
            <Button
              className="max-h-[2.5rem]"
              icon="pi pi-refresh"
              onClick={handleOnConfirmFilterTextKeterangan}
            />
          </div>
        )}
        {!isMobile && filterConfigs && filterConfigs.length > 0 && (
          <FilterComponent onFilter={handleOnFilter} configs={filterConfigs} />
        )}
        <div className={`col-center-center w-100 gap-2`}>
          {!isMobile && (
            <TableAutoComponent
              singleMode={single}
              selection={selectedRows}
              onSelectionChange={handleSelectionChange}
              configs={tableConfigs}
              loading={loading}
              value={listData}
              customColumns={customColumns}
            />
          )}
          {isMobile && (
            <DataTable
              className="w-full"
              value={listData}
              loading={loading}
              // selectionMode={"radiobutton"}
              selection={selectedRows}
              onSelectionChange={(e) => setSelectedRows(e.value)}
              stripedRows
              dataKey="id"
              showGridlines
              size="small"
            >
              <Column
                selectionMode="single"
                headerStyle={{ width: "2rem" }}
                className="!py-2"
              />
              <Column
                field="keterangan"
                header="KETERANGAN"
                className="text-sm !py-2"
                headerClassName="!py-2"
              />
            </DataTable>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default PengecekanMobilOptionSelectorDialog;
